<template>
    <div class="customer-profile registration-customer-form">
        <div class="content-area">
            <base-header
                :menu-listing="getMenuListing"
                step-style
                @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <!--<base-header v-if="configData.documentUpload==true":menu-listing="menuListing"  step-style @sidemenu="$emit('responsiveSideBar')"></base-header>-->
            <div class="right-panel">
                <div class="wrap-content customer-section">
                    <div class="filter-section">
                        <div class="row">
                            <div class="col-md-12">
                                <h2>{{ $route.meta.name }}</h2>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
import resource from '@/api/resource'
const modulesApi = new resource('configurations/modules')

export default {
    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {}, // End of Component > props

    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                status: null,
                sortBy: 'idenfoId',
                sortOrder: 'desc',
            },
            resourceApi: null,
            deepLinkRegisteredCount: 0,
            selfRegisteredCount: 0,
            configData: {
                dataSegmentId: null,
                riskFactor: null,
                liveness: null,
                nameScreening: null,
                documentUpload: null,
                companyType: null,
                counter: null,
                subscription: null,
                tier: null,
                accountinfo:null
            },
            country: process.env.VUE_APP_COUNTRY,
            menuListing: [
                {
                    // anchorLink: '/register-customer/upload-document',
                    menuLabel: 'Upload Documents',
                    sessionStep: '1',
                    name: 'edit-profile-upload-document',
                    permission: ['register-customer'],
                },

                {
                    // anchorLink: '/register-customer/setup-profile',
                    menuLabel: 'Setup Profile',
                    sessionStep: '3',
                    name: 'edit-profile-setup-profile',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/account-info',
                    menuLabel: 'Account Info',
                    sessionStep: '4',
                    name: 'edit-profile-account-info',
                    permission: ['register-customer'],
                },
                {
                    menuLabel: 'Additional Info',
                    sessionStep: '5',
                    name: 'edit-profile-additional-info',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/account-info',
                    menuLabel: 'Preview',
                    sessionStep: '6',
                    name: 'edit-profile-preview',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/finish',
                    menuLabel: 'Finish',
                    sessionStep: '7',
                    name: 'edit-profile-finish',
                    permission: ['register-customer'],
                },
            ],
        }
    }, // End of Component > data

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapGetters(['form', 'dataSegmentId', 'user']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
        getMenuListing() {
            let arr = this.menuListing
            for (var key in arr) {
                // if (this.configData.documentUpload == false && arr[key].sessionStep == 1) {
                //     arr.splice(key, 1)
                // }
                if (
                    this.configData.nameScreening == false &&
                    arr[key].sessionStep == 3
                ) {
                    arr.splice(key, 1)
                }
                // if (this.configData.riskFactor == false && arr[key].sessionStep == 4) {
                //     arr.splice(key, 1)
                // }
                if (this.configData.accountinfo ==false && arr[key].sessionStep == 4) {
                    arr.splice(key, 1)
                }
                
                if (
                    (this.configData.additionalInfo == false ||
                        this.form.type == 'company') &&
                    arr[key].sessionStep == 5
                ) {
                    arr.splice(key, 1)
                }
                // if (arr[key].sessionStep == 4) {
                //     arr.splice(key, 1)
                // }
            }
            return arr
        },
        // getMenuListing() {
        //
        //     if (this.configData.documentUpload == false) {
        //         this.menuListing.splice(0,1)
        //     }
        //     return this.menuListing
        // },
    }, // End of Component > mounted

    /*
  |--------------------------------------------------------------------------
  | Component > watch
  |--------------------------------------------------------------------------
  */
    watch: {
        dataSegmentId(value) {
            if (value) {
                // this.goToFirstStep()
                this.checkOcrSwitch()
                this.getConfigData()
            }
        },
    }, // End of Component > methods

    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    created() {
        this.$store.commit('initDefaultFields', 'form')
    },
    async mounted() {
        await this.getConfigData()
        // this.goToFirstStep()
        // this.$store.commit('initDefaultFields', 'form')
        await this.updateIdentityInfo()
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        /**
         * go to the first step
         *
         * @return {void}
         */
        goToFirstStep() {
            if (
                ![
                    //'setup-profile',
                    'edit-profile-upload-document',
                ].includes(this.$route.name)
            ) {
                // if (this.$route.meta.publicRegistration === true)
                {
                    // if(this.configData.documentUpload == true)
                    // {
                    //     this.$router.push({
                    //         name: 'edit-profile-upload-document',
                    //         params: {
                    //             dataSegmentId: this.dataSegmentId,
                    //         },
                    //     })
                    // }
                    // else
                    // {
                    //     this.$router.push({
                    //         name: 'edit-profile-setup-profile',
                    //         params: {
                    //             dataSegmentId: this.dataSegmentId,
                    //         },
                    //     })
                    // }
                    this.$router.push({
                        name: 'edit-profile-upload-document',
                        params: {
                            dataSegmentId: this.dataSegmentId,
                        },
                    })
                }
                // else {
                //     this.$router.push({
                //         name: 'setup-profile',
                //     })
                // }
            }
        }, // End of goToFirstStep() method

        /**
         * check if the ocr switch configurations
         * is on for this data segment
         *
         * @return {void}
         */
        async getConfigData() {
            try {
                if (this.dataSegmentId) {
                    let { data } = await modulesApi.list({
                        dataSegmentId: this.dataSegmentId,
                    })
                    if (!_.isEmpty(data.data)) {
                        this.configData = data.data
                        this.$store.state.registration.configData = data.data
                    }
                    this.showPageLoader = false
                }
            } catch (error) {
                this.showPageLoader = false
            }
        },

        async updateIdentityInfo() {
            if (process.env.VUE_APP_COUNTRY == 'Pakistan') {
                this.$store.commit('updateField', {
                    key: 'identityInfo.type',
                    value: 'id',
                })
            } else {
                this.$store.commit('updateField', {
                    key: 'identityInfo.type',
                    value: 'passport',
                })
            }
        },
    }, // End of Component > watch
} // End of export default
</script>
